import React from "react";
import Warning from '../img/warning.svg';

const LimitPage = () => {
    return(
        <div style={{position: 'absolute', width: '100%', height: '100%', backgroundColor: 'white', top: 0, zIndex: '10', display: "flex", flexDirection: 'column', alignItems: 'center ', justifyContent: 'center'}}>
            <img src={Warning} alt="alert" style={{width: '35%'}}/>
            <h1 style={{textAlign: 'center', color: "#ff0f64", fontWeight: '600'}}>Limite richieste raggiunto</h1>
            <p style={{backgroundColor: 'white', width: '90%', textAlign: 'center', borderRadius: '13px', color: 'grey', fontWeight: '500', fontSize: '1.2rem'}}>Richiedi al proprietario della pagina di aumentare il suo piano se desideri continuare ad utilizzare questo tool su questa pagina.</p>
        </div>
    )
}

export default LimitPage;